import { Component, OnInit, Input } from '@angular/core';
import { Router, RouterEvent, NavigationStart, NavigationEnd } from '@angular/router';
import 'rxjs/add/operator/filter';
import { GlobalVariable } from '../../global.variables';
import { BreadCrumb } from './breadcrumb.model';

import * as $ from 'jquery';
import { CommonService } from '../../services/common.service';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: 'breadcrumb.component.html'
})

export class BreadCrumbComponent implements OnInit {
    @Input() activeItem: string;
    breadCrumbItems: BreadCrumb[];
    activeComp: BreadCrumb;
    continue: boolean;

    constructor(
        private _router: Router,
        private _global: GlobalVariable,
        private _commonService: CommonService) {
        this.continue = true;
    }

    getBreadCrumb(url: string) {
        url = url.replace(new RegExp('/', 'g'), '$');
        if (url.indexOf('search') === -1 && url.indexOf('manage') === -1) {
            this._commonService.getBreadCrumbByUrl(url).subscribe((res: BreadCrumb[]) => {
                this.breadCrumbItems = res;
                this.activeComp = this.breadCrumbItems[this.breadCrumbItems.length - 1];
                this.breadCrumbItems.pop();
            });
        }
    }

    ngOnInit() {
        this.getBreadCrumb(document.URL.replace(/^.*\/\/[^\/]+/, ''));
        this._router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this._global.lastUrl !== event.url) {
                    this._global.lastUrl = event.url;
                    this.getBreadCrumb(event.url);
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/opc/shared/components/breadcrumb/breadcrumb.component.ts